<template>
  <div class="job-milestones-main">
    <div
      class="left-container"
      :style="{
        maxWidth: hideLeftContainer ? '0px' : '250px',
        minWidth: hideLeftContainer ? '0px' : '250px',
        padding: hideLeftContainer ? '0px' : '5px',
      }"
    >
      <div class="button-section">
        <button @click="resetClicked">Reset</button>
        <button @click="saveWatchListClicked">Save Watch List</button>
        <button @click="refreshClicked">Refresh</button>
        <!-- <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-refresh-64.png" @click="refreshClicked"> -->
      </div>

      <div class="separator"></div>

      <div class="date-section">
        <Dropdown
          placeholder="Date Field"
          :items="dateFieldItems"
          itemKey="Date Field"
          :selectedObject.sync="filteredDateField"
          :errorMessage.sync="dateFieldError"
          :isRequired="true"
        />
        <div style="display: flex">
          <CheckBox title="" :isChecked.sync="jobDateSelect" />
          <Dropdown
            placeholder="Date Option"
            :isDisabled="!jobDateSelect"
            :items="dateOptionItems"
            itemKey="Date Option"
            :selectedObject.sync="filteredDateOption"
            :errorMessage.sync="dateOptionError"
            :isRequired="jobDateSelect"
          />
        </div>
        <div style="display: flex">
          <CheckBox title="" :isChecked.sync="jobDateRange" />
          <div>
            <DateTimePicker
              placeholder="From"
              :isDisabled="!jobDateRange"
              :value.sync="filteredStart"
              :isRequired="jobDateRange"
              :errorMessage.sync="fromError"
            />
            <DateTimePicker
              placeholder="To"
              :isDisabled="!jobDateRange"
              :value.sync="filteredEnd"
              :isRequired="jobDateRange"
              :errorMessage.sync="toError"
            />
          </div>
        </div>
      </div>

      <div class="separator"></div>

      <Dropdown
        placeholder="View Options"
        :items="servicePersonItems"
        itemKey="Service Jobs"
        :selectedObject.sync="filteredServicePerson"
        :isRequired="true"
        :errorMessage.sync="servicePersonError"
      />

      <Dropdown
        placeholder="Status List Category"
        :items="statusListCategoryItems"
        itemKey="Description"
        :selectedObject.sync="filteredStatusListCategory"
        :isRequired="true"
        :errorMessage.sync="statusListCategoryError"
      />

      <div class="separator"></div>

      <div class="filters">
        <div v-for="(f, index) in filterItems" :key="index" class="filter-items">
          <div v-if="index !== 4" class="filter-title">
            <div>{{ f.title }}</div>
            <button v-if="index < 4" @click="addClicked(index)">
              <img src="https://dsmapi.logistics.systems/dsm6gicons/icons8-edit-64.png" height="15" width="15" />
            </button>
          </div>
          <div v-else class="filter-title">
            <div>
              <div>
                <Dropdown
                  placeholder=""
                  :items="[{ title: 'Job #' }, { title: 'Project #' }]"
                  itemKey="title"
                  :selectedObject.sync="f.selectedType"
                  :isRequired="false"
                  class="filter-dropdown"
                />
              </div>
            </div>
          </div>
          <div v-if="index < 4" class="filter-details">
            <div v-if="f.selected.length == 0">All</div>
            <div v-for="(s, i) in f.selected" :key="i" class="item" :title="s[f.itemDesc]">
              {{ s[f.itemKey] }}
            </div>
            <div v-if="f.error" class="filter-empty"> Please select at least 1 {{ f.title }} </div>
          </div>
          <textarea v-else-if="index === 4" v-model="f.value"></textarea>
          <textarea v-else :title="`Enter the ${f.title}, 1 ${f.title} per line`" v-model="f.value"></textarea>
        </div>
      </div>
    </div>

    <div
      class="right-container"
      :style="{
        maxWidth: hideLeftContainer ? '100%' : 'calc(100% - 250px)',
        minWidth: hideLeftContainer ? '100%' : 'calc(100% - 250px)',
      }"
    >
      <div class="selected-filters">
        <div class="filter-row">
          <div class="filter-title">Total Jobs</div>
          <div class="colon-separator">:</div>
          <div class="filter-details">{{ totalJob }}</div>
        </div>
        <div class="filter-row">
          <div class="filter-title">{{
            typeof milestonesItem['datefield'] == 'object' ? '' : milestonesItem['datefield']
          }}</div>
          <div class="colon-separator">:</div>
          <div class="filter-details">
            <div v-if="milestonesItem['dateoption']" :title="milestonesItem['dateoption']" class="details-item">
              {{ typeof milestonesItem['dateoption'] == 'object' ? '' : milestonesItem['dateoption'] }}
            </div>
            <div v-else :title="`${milestonesItem.startdate} - ${milestonesItem.enddate}`" class="details-item">
              {{ milestonesItem.startdate }} -<br />{{ milestonesItem.enddate }}
            </div>
          </div>
          <div class="filter-title">Customer</div>
          <div class="colon-separator">:</div>
          <div class="filter-details">
            <div :title="milestonesItem.customer ? milestonesItem.customer : 'All'" class="details-item">
              {{ milestonesItem.customer ? milestonesItem.customer : 'All' }}
            </div>
          </div>
        </div>
        <div class="filter-row">
          <div class="filter-title">Service Person</div>
          <div class="colon-separator">:</div>
          <div class="filter-details">
            <div v-if="milestonesItem.servicejob" :title="milestonesItem.servicejob" class="details-item">
              {{ milestonesItem.servicejob }}
            </div>
          </div>
          <div class="filter-title">Shpr / Csgn</div>
          <div class="colon-separator">:</div>
          <div class="filter-details">
            <div :title="milestonesItem.shprcsgn ? milestonesItem.shprcsgn : 'All'" class="details-item">
              {{ milestonesItem.shprcsgn ? milestonesItem.shprcsgn : 'All' }}
            </div>
          </div>
        </div>
        <div class="filter-row">
          <div class="filter-title">Job Type</div>
          <div class="colon-separator">:</div>
          <div class="filter-details">
            <div :title="milestonesItem.sysjobtype ? milestonesItem.sysjobtype : 'All'" class="details-item">
              {{ milestonesItem.sysjobtype ? milestonesItem.sysjobtype : 'All' }}
            </div>
          </div>
          <div class="filter-title">Project #</div>
          <div class="colon-separator">:</div>
          <div class="filter-details">
            <div :title="milestonesItem.projectno ? milestonesItem.projectno : 'All'" class="details-item">
              {{ milestonesItem.projectno ? milestonesItem.projectno : 'All' }}
            </div>
          </div>
        </div>
        <div class="filter-row">
          <div class="filter-title">Trans Mode</div>
          <div class="colon-separator">:</div>
          <div class="filter-details">
            <div :title="milestonesItem.transmode ? milestonesItem.transmode : 'All'" class="details-item">
              {{ milestonesItem.transmode ? milestonesItem.transmode : 'All' }}
            </div>
          </div>
          <div class="filter-title">Ref #</div>
          <div class="colon-separator">:</div>
          <div class="filter-details">
            <div :title="milestonesItem.refno ? milestonesItem.refno : 'All'" class="details-item">
              {{ milestonesItem.refno ? milestonesItem.refno : 'All' }}
            </div>
          </div>
        </div>

        <div class="last-refresh">Last Refreshed : {{ lastRefresh }}</div>
        <div v-if="!milestonesItem" class="empty-watch-list"> No selected watch list </div>

        <div
          class="close-button"
          @click="hideLeftContainer = !hideLeftContainer"
          :title="hideLeftContainer ? 'Show filters section' : 'Hide filters section'"
        >
          <img
            src="https://img.icons8.com/metro/26/000000/double-left.png"
            height="15"
            width="15"
            :style="{ transform: `rotate(${hideLeftContainer ? '180' : '0'}deg)` }"
          />
        </div>
      </div>

      <div class="legend">
        <div
          class="legend-item"
          v-for="(l, index) in legends"
          :key="index"
          @click="legendClicked(index)"
          :style="{
            backgroundColor: l.active ? l.color : 'white',
            border: `3px solid ${l.color}`,
            textDecoration: l.active ? 'none' : 'line-through',
          }"
        >
          {{ l.title }}
        </div>
      </div>

      <div class="jobs" @scroll="jobAreaScrolled" ref="jobArea">
        <div class="jobs-row" v-for="(j, jInd) in allJobs" :key="jInd">
          <div class="job-number">{{ j['#'] }}. </div>
          <div class="jobs-header">
            <div class="billto-name" v-for="(t, ti) in j['Col1Text'].split('\n')" :key="ti" :title="t.trim()">
              {{ t.trim() }}
              <img
                v-if="t.trim().startsWith('ETA:') && getTransportIcon(j['Trans Desc'])"
                :src="getTransportIcon(j['Trans Desc'])"
                class="transport-icon"
                :title="j['Trans Desc']"
              />
            </div>
            <!-- User ID row -->
            <div class="job-footer">
              <div class="billto-name user-id" v-if="j.UserID">
                <img src="https://dsmlib.logistics.systems/Icons/user.png" class="user-icon" title="Created By" />
                <span>{{ j.UserID }}</span>
              </div>
            </div>
          </div>

          <div class="image-wrapper">
            <img
              v-if="j['DocCount'] != '0'"
              src="https://i.ibb.co/0QC3YFs/icons8-attach-50.png"
              height="20"
              width="20"
              @click="viewAttachments(j, false)"
              :title="`View Attachment (${j['DocCount']})`"
            />
            <img
              src="https://dsmlib.logistics.systems/Icons/icons8-ellipsis-100.png"
              @click="moreButtonClicked(jInd)"
              tabindex="1"
              height="20"
              width="20"
              @blur="showMoreUnfocus"
            />
            <div
              v-if="showMoreList[jInd]"
              @mouseenter="closeMoreMenu = false"
              @mouseleave="closeMoreMenu = true"
              class="more-menu"
              :style="{ transform: jInd == 0 ? 'translateY(calc(100% - 25px))' : '' }"
            >
              <div class="arrow" :style="{ top: jInd == 0 ? '5px' : 'calc(100% - 25px)' }"></div>

              <router-link
                class="show-more-item"
                :to="`/Home/${userParam}/Status?jobno=${encodeURIComponent(allJobs[jInd]['Job No'])}`"
                target="_blank"
                >View TAS & KPI</router-link
              >
              <router-link
                v-if="allJobs[jInd]['System'] == 'FMS'"
                class="show-more-item"
                :to="{
                  path: `/Home/${userParam}/FreightForwarding/${allJobs[jInd]['System'] == 'I' ? 'Import%20Job' : 'Export%20Job'}`,
                  query: {
                    job: encodeURIComponent(allJobs[jInd]['Job No']),
                    date: encodeURIComponent(allJobs[jInd]['Job Date']),
                  },
                }"
                target="_blank"
                >View Job File</router-link
              >
              <router-link class="show-more-item" to="" @click.native="containerUpdate(jInd)"
                >Container Status</router-link
              >
            </div>
          </div>

          <div class="tas-details" :id="j['#']"></div>
        </div>
      </div>
    </div>

    <div v-if="showTabulator" class="tabulator-popup">
      <div class="popup-container">
        <div class="popup-header">
          <div class="title"> Select {{ tablePopupTitle }} (Max {{ maxSelection }} items) </div>
          <CheckBox title="Show Selected Only" :isChecked.sync="showSelectedOnly" />
        </div>
        <Tabulator
          style="height: calc(100% - 100px)"
          :tableData="tableData"
          :selectedRow.sync="selectedItem"
          ref="popupTable"
          :multiSelect="maxSelection"
          :rollingSelection="false"
          :currentRowSize="50"
        />
        <div class="confirm-cancel-buttton">
          <button @click="confirmClicked">
            {{ selectedItem.length > 0 ? `Confirm ${selectedItem.length} items` : 'Select All' }}
          </button>
          <button @click="showTabulator = false">Cancel</button>
        </div>
      </div>
    </div>

    <!--Attachment Window-->
    <div class="attchWin-main" v-if="openPopup">
      <button class="attchWin-close" @click="closePopup()">X</button>
      <div class="attchWin-display" v-if="this.attachmentList.length > 0">
        <div class="left">
          <div v-if="this.attachmentList.length > 1" class="leftButton">
            <button class="navButton-left" @click="navAtt('prev')">&lt;</button>
          </div>

          <!-- image container and buttons -->
          <div class="attchWin-attachment">
            <iframe
              v-if="
                this.attToView['AttImageType'] === '.ogg' ||
                this.attToView['AttImageType'] === '.pdf' ||
                this.attToView['AttImageType'] === 'application/pdf'
              "
              :src="this.attToView['AttImage']"
            />
            <img
              v-else-if="
                this.attToView['AttImageType'] === '.jpg' ||
                this.attToView['AttImageType'] === 'image/Jpeg' ||
                this.attToView['AttImageType'] === '.jpeg' ||
                this.attToView['AttImageType'] === 'image/jpeg' ||
                this.attToView['AttImageType'] === '.png' ||
                this.attToView['AttImageType'] === '.gif' ||
                this.attToView['AttImageType'] === 'n/a'
              "
              :src="this.attToView['AttImage']"
            />
            <img
              style="width: 30%"
              v-else-if="this.attToView['AttImageType'] === '.docx'"
              src="https://i.ibb.co/PtPtyLZ /word.png"
              @click="downloadpop()"
            />
            <img
              style="width: 30%"
              v-else-if="this.attToView['AttImageType'] === '.pptx'"
              src="https://i.ibb.co/n3904Sm/ppt.png"
              @click="downloadpop()"
            />
            <img
              style="width: 30%"
              v-else-if="this.attToView['AttImageType'] === '.msg' || this.attToView['AttImageType'] === '.eml'"
              src="https://i.ibb.co/sjQCXt2/mail.png"
              @click="downloadpop()"
            />
            <img
              style="width: 30%"
              v-else-if="this.attToView['AttImageType'] === '.xlsx'"
              src="https://i.ibb.co/JFp0hrh/excel.png"
              @click="downloadpop()"
            />
            <img style="width: 30%" v-else :src="this.attToView['AttImage']" />
          </div>

          <div v-if="this.attachmentList.length > 1" class="rightButton">
            <button class="navButton-right" @click="navAtt('next')">></button>
          </div>
        </div>

        <div class="right">
          <div class="count">
            <b>{{ this.attToView['#'] }}</b> / {{ this.totalAtt }} Attachments
          </div>
          <div class="attchWin-info">
            <table id="infoHeader">
              <tr>
                <th>Job No</th>
                <td>:{{ this.attToView['Job No'] }}</td>
              </tr>

              <tr>
                <th>Status</th>
                <td>:{{ this.attToView['Status'] }}</td>
              </tr>

              <tr>
                <th>Remarks</th>
                <td>:{{ this.attToView['Remarks'] }}</td>
              </tr>
            </table>

            <table id="tableContent">
              <tr>
                <th>#</th>
                <td>{{ this.attToView['#'] }}</td>
              </tr>

              <tr>
                <th>Reference No</th>
                <td>{{ this.attToView['Reference No'] }}</td>
              </tr>

              <tr>
                <th>Category</th>
                <td>{{ this.attToView['Category'] }}</td>
              </tr>

              <tr>
                <th>Type</th>
                <td>{{ this.attToView['Type'] }}</td>
              </tr>

              <tr>
                <th>Received Time</th>
                <td>{{ this.attToView['Received DateTime'] }}</td>
              </tr>

              <tr>
                <th>Document Date</th>
                <td>{{ this.attToView['Document Date'] }}</td>
              </tr>

              <tr>
                <th>Consignment No</th>
                <td>{{ this.attToView['Consignment No'] }}</td>
              </tr>

              <tr>
                <th>Container No</th>
                <td>{{ this.attToView['Container No'] }}</td>
              </tr>

              <tr>
                <th>UserID</th>
                <td>{{ this.attToView['UserID'] }}</td>
              </tr>

              <tr>
                <th>DocumentGUID</th>
                <td>{{ this.attToView['DocumentGUID'] }}</td>
              </tr>

              <tr>
                <th>File Type</th>
                <td>{{ this.attToView['AttImageType'] }}</td>
              </tr>
            </table>
          </div>
        </div>
      </div>

      <div v-else class="attchWin-display">
        <div style="margin: 0 auto">No Attachments Found</div>
      </div>
    </div>

    <DocStatusUpdate
      :showPopup.sync="containerUpdatePopup"
      defaultCategory="container"
      :jobno="containerJobNo"
      :title="`Update Container Status for Job # ${containerJobNo}`"
    />

    <Loader :isVisible.sync="loading" :loadingText="loadText" />
  </div>
</template>

<script>
/* eslint-disable */
import Tabulator from '@/components/Tabulator.vue';

export default {
  components: {
    Tabulator,
  },
  data: function () {
    return {
      loading: false,
      loadText: '',
      showMoreList: [],
      closeMoreMenu: true,

      jobDateSelect: true,
      jobDateRange: false,

      filteredDateField: null,
      filteredDateOption: null,
      filteredServicePerson: null,
      filteredStatusListCategory: null,

      filteredStart: null,
      filteredEnd: null,

      dateFieldError: '',
      dateOptionError: '',
      servicePersonError: '',
      statusListCategoryError: '',
      fromError: '',
      toError: '',

      dateFieldItems: [],
      dateOptionItems: [],

      servicePersonItems: [],
      milestonesItem: {},
      statusListCategoryItems: [],

      legends: [],
      selectedLegend: [],

      allJobs: [],

      totalJob: 0,
      lastRefresh: '',
      jobsFromAPI: [],

      openedIndex: -1,
      showTabulator: false,

      selectedItem: [],
      tablePopupTitle: '',
      tableData: [],

      hideLeftContainer: false,

      containerUpdatePopup: false,
      containerJobNo: '',
    };
  },
  props: {
    //getJobDocuments
    userID: { type: String, default: '' },
    config: { type: String, default: '' },

    showSelectedOnly: { type: Boolean, default: false },

    maxJobToShow: { type: Number, default: 25 },

    maxSelection: { type: Number, default: 50 },

    filterItems: {
      type: Array,
      default: function () {
        return [
          { title: 'Job Type', items: [], selected: [], itemKey: 'JobType', itemDesc: 'Description', error: false },
          {
            title: 'Trans Mode',
            items: [],
            selected: [],
            itemKey: 'Trans Mode',
            itemDesc: 'Description',
            error: false,
          },
          {
            title: 'Customer',
            items: [],
            selected: [],
            itemKey: 'Customer Code',
            itemDesc: 'Customer Name',
            error: false,
          },
          {
            title: 'ShprCsgn',
            items: [],
            selected: [],
            itemKey: 'ShprCsgn Code',
            itemDesc: 'ShprCsgn Name',
            error: false,
          },
          { title: 'Job # / Project #', value: '', selectedType: { title: 'Job #' } },
          { title: 'Ref # / Cont #', value: '' },
        ];
      },
    },

    currentJobs: {
      type: Object,
      default: function () {
        return {};
      },
    },

    // To post object
    // filteredStart: { type: Date, default: function () { return null; }, },
    // filteredEnd: { type: Date, default: function () { return null; }, },
    //to view attachments
    openPopup: { type: Boolean, default: false },
    attachmentList: {
      type: Array,
      default: function () {
        return [];
      },
    },
    attToView: {
      type: Array,
      default: function () {
        return [];
      },
    },
    noAtt: { type: Boolean, default: false },
    totalAtt: { type: String, default: '' },
  },
  methods: {
    viewAttachments: async function (array, haveStatus) {
      if (!haveStatus && array['Job No'] == null) {
        alert('No specified job number!');
        return;
      } else if (haveStatus && array['Status'] == null) {
        alert('No specified status!');
        return;
      } else if (array['Job No'] == null && array['Status'] == null) {
        alert('No specified job number and status!');
        return;
      }

      try {
        this.loading = true;
        this.loadText = 'Getting Attachments';
        var status = array['Status'];
        this.attachmentList = [];

        if (!haveStatus) {
          this.attachmentList = await this.$apiCallV2('/JobMilestones/GetJobDocuments?jobno=' + array['Job No']);
        } else {
          // Test
          this.attachmentList = await this.$apiCallV2(
            '/JobMilestones/GetJobDocuments?jobno=' + array['Job No'] + '&status=' + status,
          );
        }

        //if no attachments, show "no attachments"
        if (this.attachmentList.length < 1 || !this.attachmentList) {
          this.noAtt = true;
        } else {
          this.noAtt = false;
          this.convertImage(this.attachmentList);
          this.attToView = this.attachmentList[0];
          this.totalAtt = this.attachmentList.length;

          for (var i = 0; i < this.attachmentList.length; i++) {
            // this.attachmentList[i]["Received DateTime"] = this.parseJsonDate(
            //   this.attachmentList[i]["Received DateTime"]
            // );
            // this.attachmentList[i]["Document Date"] = this.parseJsonDate(
            //   this.attachmentList[i]["Document Date"]
            // );
            this.attachmentList[i]['AttImageType'] = this.myTrim(this.attachmentList[i]['AttImageType']);

            for (var key in this.attachmentList[i]) {
              if (this.attachmentList[i].hasOwnProperty(key)) {
                if (
                  this.attachmentList[i][key] === '' ||
                  this.attachmentList[i][key] == null ||
                  !this.attachmentList[i][key]
                ) {
                  this.attachmentList[i][key] = 'null';
                }
              }
            }
          }
        }

        this.openPopup = true;
        this.loading = false;
      } catch (e) {
        this.loading = false;
      }
    },
    myTrim: function (x) {
      return x.replace(/^\s+|\s+$/gm, '');
    },
    convertImage: function (data) {
      //loop to get and convert all attImg
      try {
        for (var j = 0; j < data.length; j++) {
          if (data[j]['AttImageType'] == null) {
            data[j]['AttImageType'] = 'n/a';
          } else {
            var type = data[j]['AttImageType'].trim();
          }

          //if empty
          if (data[j]['AttImage'] == null || data[j]['AttImage'].length == 0) {
            data[j]['AttImage'] = 'https://i.ibb.co/kyZfpjx/no-image.png';

            //if value = pdf file
          } else if (type === '.pdf' || type === 'application/pdf') {
            //qyvoon 20210520
            var b64Data = data[j]['AttImage'];
            const byteCharacters = atob(b64Data);
            const byteArrays = [];
            var sliceSize = 512;
            for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
              const slice = byteCharacters.slice(offset, offset + sliceSize);
              const byteNumbers = new Array(slice.length);
              for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
              }
              const byteArray = new Uint8Array(byteNumbers);
              byteArrays.push(byteArray);
            }
            const blob = new Blob(byteArrays, { type: 'application/pdf' });
            const fileurl = URL.createObjectURL(blob);
            data[j]['AttImage'] = fileurl;
          } else if (type === '.xlsx') {
            data[j]['AttImage'] =
              'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,' +
              data[j]['AttImage'] +
              '==';
          } else if (type === '.ogg') {
            data[j]['AttImage'] = 'data:audio/ogg;base64,' + data[j]['AttImage'];
          } else if (type === '.pptx') {
            data[j]['AttImage'] =
              'data:application/vnd.openxmlformats-officedocument.presentationml.presentation;base64,' +
              data[j]['AttImage'].substring(0, data[j]['AttImage'].length - 4);
          } else if (type === '.docx') {
            data[j]['AttImage'] =
              'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64,' +
              data[j]['AttImage'];
          } else if (type === '.msg') {
            data[j]['AttImage'] = 'data:application/vnd.msoutlook;base64,' + data[j]['AttImage'];
          } else if (
            type === '.jpeg' ||
            type === '.jpg' ||
            type === 'image/Jpeg' ||
            type === '.jpeg' ||
            type === 'image/jpeg' ||
            type === '.png' ||
            type === '.gif'
          ) {
            data[j]['AttImage'] = 'data:image/png;base64,' + data[j]['AttImage'];
          } else {
            data[j]['AttImage'] = 'data:application/octet-stream;base64,' + data[j]['AttImage'];
          }
        }
      } catch (e) {}
    },
    parseJsonDate: function (jsonDateString, value) {
      try {
        if (jsonDateString != null) {
          var xformatedDate = new Date(parseInt(jsonDateString.replace('/Date(', '')));
          function pad(s) {
            return s < 10 ? '0' + s : s;
          }

          var d = new Date(xformatedDate);

          return [d.getFullYear(), pad(d.getMonth() + 1), pad(d.getDate())].join('-');
        } else {
          return 'No Date';
        }
      } catch (e) {
        alert(e);
      }
    },
    navAtt: function (clicked) {
      var getIndex = this.attToView;
      var inArray = this.attachmentList.indexOf(getIndex);

      var curr = getIndex['#'] - 1;
      var next;
      var length = this.attachmentList.length;
      var end = length - 1;

      if (clicked == 'prev') {
        if (inArray == 0) {
          next = end;
        } else {
          next = inArray - 1;
        }
      } else {
        if (inArray == end) {
          next = 0;
        } else {
          next = inArray + 1;
        }
      }

      this.attToView = this.attachmentList[next];
    },
    downloadpop: function () {
      var doc = this.attToView['AttImage'];
      var status = this.attToView['Status'].trim();

      var type = this.attToView['AttImageType'].trim();

      var link = document.createElement('a');
      link.href = doc;
      link.download = this.attToView['Job No'].trim() + '_' + status + type;
      link.click();
    },
    addClicked: function (index) {
      this.openedIndex = index;
      this.showTabulator = true;
      this.tablePopupTitle = this.filterItems[index].title;
      this.tableData = this.filterItems[index].items;
      this.filterItems[index].error = false;

      this.$nextTick(() => {
        var selected = this.filterItems[index].selected;
        var key = this.filterItems[index].itemKey;
        var indexes = [];

        selected.forEach((s) => {
          var item = this.tableData.filter((d) => {
            return d[key] == s[key];
          });
          indexes.push(this.tableData.indexOf(item[0]));
        });

        this.$refs.popupTable.selectRow(indexes);

        // this.loading = true;
        // this.loadText = 'Loading';

        // setTimeout(() => {
        //   this.loading = false;
        // }, selected.length * 100);
      });
    },
    confirmClicked: function () {
      this.filterItems[this.openedIndex].selected = this.selectedItem;
      this.showTabulator = false;
    },
    resetClicked: async function () {
      this.$fullscreenLoading('Getting Saved Watch List');
      let milestones = await this.$apiCallV2('/JobMilestones/GetSettingsSystemUser?settingsitem=JobMilestones');
      this.$fullscreenLoading();

      this.milestonesItem = milestones[0].SettingsValue ? JSON.parse(milestones[0].SettingsValue) : {};
      if (!this.milestonesItem || Object.keys(this.milestonesItem).length == 0) {
        this.$showAlert(
          'info',
          'No saved watch list',
          'You currently have no saved watch list. You may configure your watch list from the left menu.',
        );
      } else {
        this.filteredDateField = this.milestonesItem['datefield'];

        if (this.milestonesItem['dateoption']) {
          this.filteredDateOption = this.milestonesItem['dateoption'];
          this.jobDateRange = false;
          this.jobDateSelect = true;
        } else {
          this.jobDateRange = true;
          this.jobDateSelect = false;
          this.filteredStart = new Date(this.milestonesItem['startdate']);
          this.filteredEnd = new Date(this.milestonesItem['enddate']);
        }
        this.filteredServicePerson = this.milestonesItem['servicejob'];
        this.filteredStatusListCategory = this.milestonesItem['statuslistcategory'];

        var jobTypeFiltered = [];
        var jobKey = this.filterItems[0].itemKey;
        this.milestonesItem['sysjobtype'].split(',').forEach((s) => {
          var item = this.filterItems[0].items.filter((i) => {
            return i[jobKey] == s;
          });
          if (item[0]) {
            jobTypeFiltered.push(item[0]);
          }
        });
        this.filterItems[0].selected = jobTypeFiltered;

        var transmodeFiltered = [];
        var transModeKey = this.filterItems[1].itemKey;
        this.milestonesItem['transmode'].split(',').forEach((s) => {
          var item = this.filterItems[1].items.filter((i) => {
            return i[transModeKey] == s;
          });
          if (item[0]) {
            transmodeFiltered.push(item[0]);
          }
        });
        this.filterItems[1].selected = transmodeFiltered;

        var customerFiltered = [];
        var customerKey = this.filterItems[2].itemKey;
        this.milestonesItem['customer'].split(',').forEach((s) => {
          var item = this.filterItems[2].items.filter((i) => {
            return i[customerKey] == s;
          });
          if (item[0]) {
            customerFiltered.push(item[0]);
          }
        });
        this.filterItems[2].selected = customerFiltered;

        var shprCsgnFiltered = [];
        var shprCsgnKey = this.filterItems[3].itemKey;
        this.milestonesItem['shprcsgn'].split(',').forEach((s) => {
          var item = this.filterItems[3].items.filter((i) => {
            return i[shprCsgnKey] == s;
          });
          if (item[0]) {
            shprCsgnFiltered.push(item[0]);
          }
        });
        this.filterItems[3].selected = shprCsgnFiltered;

        this.refreshClicked();
      }
    },
    refreshClicked: async function () {
      let tasks = Array.from(document.getElementsByClassName('tas-details'));
      tasks.forEach((t) => {
        t.innerHTML = '';
      });
      if (this.isRequiredEmpty()) {
        return;
      }

      var key0 = this.filterItems[0].itemKey;
      var key1 = this.filterItems[1].itemKey;
      var key2 = this.filterItems[2].itemKey;
      var key3 = this.filterItems[3].itemKey;
      this.filterItems[4].selectedType =
        this.filterItems[4].selectedType ? this.filterItems[4].selectedType : { title: 'Job #' };

      this.loading = true;
      this.loadText = 'Refreshing';

      let toPost = {
        datefield: this.filteredDateField ? this.filteredDateField['Date Field'] : '',
        dateoption:
          this.jobDateSelect ?
            this.filteredDateOption ?
              this.filteredDateOption['Date Option']
            : ''
          : '',
        startdate: this.jobDateRange ? this.$dateTime.getDateTime(this.filteredStart, 'yyyy-MM-dd HH:mm') : '',
        enddate: this.jobDateRange ? this.$dateTime.getDateTime(this.filteredEnd, 'yyyy-MM-dd HH:mm') : '',
        servicejob: this.filteredServicePerson ? this.filteredServicePerson['Service Jobs'] : '',
        statuslistcategory: this.filteredStatusListCategory ? this.filteredStatusListCategory['List Category'] : '',
        sysjobtype:
          this.filterItems[0].selected ?
            this.filterItems[0].selected
              .map((s) => {
                return s[key0];
              })
              .join(',')
          : '',
        transmode:
          this.filterItems[1].selected ?
            this.filterItems[1].selected
              .map((s) => {
                return s[key1];
              })
              .join(',')
          : '',
        customer:
          this.filterItems[2].selected ?
            this.filterItems[2].selected
              .map((s) => {
                return s[key2];
              })
              .join(',')
          : '',
        shprcsgn:
          this.filterItems[3].selected ?
            this.filterItems[3].selected
              .map((s) => {
                return s[key3];
              })
              .join(',')
          : '',
        jobno:
          this.filterItems[4].selectedType.title === 'Job #' ? this.filterItems[4].value.split('\n').join(',') : '',
        projectno:
          this.filterItems[4].selectedType.title === 'Project #' ? this.filterItems[4].value.split('\n').join(',') : '',
        refno: this.filterItems[5].value.split('\n').join(','),
      };
      var jobMilstone = await this.$apiCallV2('/JobMilestones/GetJobMilestones', toPost);

      this.legends = [];
      this.selectedLegend = [];
      this.allJobs = [];

      if (jobMilstone) {
        this.jobsFromAPI = jobMilstone.JobMilestones.Job;

        if (!Array.isArray(this.jobsFromAPI)) {
          this.jobsFromAPI = [this.jobsFromAPI];
        }

        this.totalJob = this.jobsFromAPI.length;

        var index = 1;
        this.jobsFromAPI.forEach((j) => {
          j['#'] = index;
          index++;
        });

        if (this.jobsFromAPI.length > this.maxJobToShow) {
          for (var i = 0; i < this.maxJobToShow; i++) {
            this.allJobs.push(this.jobsFromAPI[i]);
          }
        } else {
          this.allJobs = this.jobsFromAPI;
        }

        Object.keys(jobMilstone.Legend).forEach((k) => {
          this.legends.push({
            title: k,
            color: jobMilstone.Legend[k],
            active: true,
          });
          this.selectedLegend.push(k);
        });
      } else {
        this.allJobs = [];
        this.totalJob = 0;
      }

      this.lastRefresh = this.$dateTime.getDateTime(new Date(), 'dd/MM/yyyy HH:mm:ss');

      this.milestonesItem = toPost;
      this.loading = false;

      this.allJobs.forEach((j) => this.showMoreList.push(false));

      this.$nextTick(() => {
        this.allJobs.forEach((t) => {
          var el = document.getElementById(t['#']);

          this.addJobElement(el, t['TAS'] || []);
        });
      });
    },
    saveWatchListClicked: async function () {
      if (this.isRequiredEmpty()) {
        return;
      }

      var key0 = this.filterItems[0].itemKey;
      var key1 = this.filterItems[1].itemKey;
      var key2 = this.filterItems[2].itemKey;
      var key3 = this.filterItems[3].itemKey;

      var newJob = {
        datefield: this.filteredDateField,
        dateoption: this.jobDateSelect ? this.filteredDateOption : '',
        startdate: this.jobDateRange ? this.$dateTime.getDateTime(this.filteredStart, 'yyyy-MM-dd HH:mm') : '',
        enddate: this.jobDateRange ? this.$dateTime.getDateTime(this.filteredEnd, 'yyyy-MM-dd HH:mm') : '',
        servicejob: this.filteredServicePerson,
        statuslistcategory: this.filteredStatusListCategory,
        sysjobtype: this.filterItems[0].selected
          .map((s) => {
            return s[key0];
          })
          .join(','),
        transmode: this.filterItems[1].selected
          .map((s) => {
            return s[key1];
          })
          .join(','),
        customer: this.filterItems[2].selected
          .map((s) => {
            return s[key2];
          })
          .join(','),
        shprcsgn: this.filterItems[3].selected
          .map((s) => {
            return s[key3];
          })
          .join(','),
        jobno:
          this.filterItems[4].selectedType.title === 'Job #' ? this.filterItems[4].value.split('\n').join(',') : '',
        projectno:
          this.filterItems[4].selectedType.title === 'Project #' ? this.filterItems[4].value.split('\n').join(',') : '',
        refno: this.filterItems[5].value.split('\n').join(','),
      };

      if (JSON.stringify(newJob) != JSON.stringify(this.milestonesItem)) {
        var save = await this.$showAlert(
          'warning',
          'Warning',
          'You have not refresh and view the jobs. Are you sure you want to save the current watch list?',
          [{ text: 'Save' }, { text: 'Cancel' }],
        );
        if (save === 'Cancel') {
          return;
        }
      }

      this.refreshClicked();

      this.loading = true;
      this.loadText = 'Saving your watch list';

      this.milestonesItem.isDateOption = this.jobDateSelect;
      var saveWatchList = await this.$apiCallV2(`/JobMilestones/SaveSettingsSystemUser`, newJob);

      this.loading = false;
    },
    isRequiredEmpty: function () {
      var requiredEmpty = 0;

      if (!this.filteredDateField) {
        requiredEmpty++;
        this.dateFieldError = 'Date Field is required!';
      }

      if (this.jobDateSelect && !this.filteredDateOption) {
        requiredEmpty++;
        this.dateOptionError = 'Date Option is required!';
      }

      if (this.jobDateRange && (!this.filteredStart || !this.filteredEnd)) {
        requiredEmpty++;
        if (!this.filteredStart) {
          this.fromError = 'From date is required!';
        }
        if (!this.filteredEnd) {
          this.toError = 'To date is required!';
        }
      }
      if (!this.filteredServicePerson) {
        requiredEmpty++;
        this.servicePersonError = 'View Option is required!';
      }
      if (!this.filteredStatusListCategory) {
        requiredEmpty++;
        this.statusListCategoryError = 'Status List Category is required!';
      }

      // for (var i = 0; i < 4; i++) {
      //   this.filterItems[i].error = this.filterItems[i].selected.length == 0;
      //   if (this.filterItems[i].selected.length == 0) {
      //     requiredEmpty++;
      //   }
      // }

      return requiredEmpty != 0;
    },
    legendClicked: function (index) {
      this.legends[index].active ^= true;

      if (this.legends[index].active) {
        var itemArray = Array.from(
          document.getElementsByClassName(`jobs-tas ${this.legends[index].title.split(' ').join('-')}`),
        );
        itemArray.forEach((i) => {
          i.classList.add('show-tas');
        });
      } else {
        var itemArray = Array.from(
          document.getElementsByClassName(`jobs-tas show-tas ${this.legends[index].title.split(' ').join('-')}`),
        );
        itemArray.forEach((i) => {
          i.classList.remove('show-tas');
        });
      }
    },
    jobTasHover: function (e) {
      var el = e.target;

      var details = el.childNodes[0];
      var remarks = el.childNodes[1];

      if (remarks.className == 'job-tas-remarks') {
        details.classList.add('flip-tas-details');
        remarks.classList.add('flip-remarks');
      } else if (remarks.className == 'job-tas-remarks flip-remarks') {
        details.classList.remove('flip-tas-details');
        remarks.classList.remove('flip-remarks');
      }
    },
    jobAreaScrolled: function (e) {
      var range = parseInt(this.maxJobToShow / 2);

      if (e.target.scrollTop + e.target.offsetHeight >= e.target.scrollHeight) {
        var indexFrom = parseInt(this.allJobs[this.allJobs.length - 1]['#']);
        var indexTo = indexFrom + range;
        indexTo = indexTo > this.jobsFromAPI.length ? this.jobsFromAPI.length : indexTo;

        var toAdd = this.jobsFromAPI.filter((f) => {
          return f['#'] > indexFrom && f['#'] <= indexTo;
        });

        toAdd.forEach((t) => {
          this.allJobs.push(t);
        });

        this.$nextTick(() => {
          toAdd.forEach((t) => {
            if (!t['TAS']) {
              // if this job has no updates yet, skip this iteration
              return;
            }

            this.addJobElement(document.getElementById(t['#']), t['TAS']);
          });
        });
      }
    },
    addJobElement: function (el, tas) {
      tas.forEach((t) => {
        let thisLegends = this.legends.filter((l) => l['color'] == t['BackColor'])[0];

        var detailsDiv = document.createElement('div');
        detailsDiv.classList.add('jobs-tas');
        if (thisLegends['active']) {
          detailsDiv.classList.add('show-tas');
        }
        detailsDiv.classList.add(t['Progress Status'].split(' ').join('-'));
        detailsDiv.style.backgroundColor = t['BackColor'];
        detailsDiv.innerHTML = t['ShowText'];

        var wrap = document.createElement('div');
        wrap.id = 'details-wrap';

        if (t['DocCount'] != '0') {
          var attImg = document.createElement('img');
          attImg.id = 'attImg';
          attImg.src = 'https://i.ibb.co/0QC3YFs/icons8-attach-50.png';
          attImg.title = `View Attachment (${t['DocCount']})`;
          //to access method on callback: ()'method' => this.methodNmae();
          attImg.onclick = (pointerEvent) => {
            pointerEvent.stopPropagation();
            this.viewAttachments(t, true);
          };

          wrap.appendChild(attImg);
        }

        if (t['Remarks']) {
          var remarksImg = document.createElement('img');
          remarksImg.className = 'remarks-icon';
          remarksImg.src = 'https://dsmapi.logistics.systems/dsm6gicons/icons8-comments-64.png';
          remarksImg.height = 15;
          remarksImg.width = 15;
          remarksImg.title = t['Remarks'];

          wrap.appendChild(remarksImg);
        }

        // Passing the status value to query parameter
        detailsDiv.addEventListener('click', () => {
          const jobNo = encodeURIComponent(t['Job No']);
          const url = `/Home/${this.userParam}/Status?jobno=${jobNo}&status=${t['Status']}`;
          window.open(url, '_blank'); // Opens the URL in a new tab
        });

        el.appendChild(detailsDiv);
        detailsDiv.appendChild(wrap);
      });
    },
    getLoginDetails: async function () {
      let details = await this.$apiCallV2('/Login/GetDetails');

      this.userID = details.LoginUserID;
      this.config = details.ConfigCode;
    },
    closePopup: function () {
      this.attachmentList = '';
      this.openPopup = false;
    },
    moreButtonClicked: function (index) {
      this.$set(this.showMoreList, index, true);
    },
    showMoreUnfocus: function () {
      if (this.closeMoreMenu) {
        this.showMoreList = new Array(this.showMoreList.length).fill(false);
      }
    },
    moreMenuItemClicked: function (type, index) {
      this.showMoreList = new Array(this.showMoreList.length).fill(false);
      let job = this.allJobs[index];

      let url = '';
      if (type == 'TAS') {
        url = `/Home/${this.$route.params['user']}/Status?jobno=${encodeURIComponent(job['Job No'])}`;
      } else if (type == 'job') {
        url = `/Home/${this.$route.params['user']}/FreightForwarding/Import%20Job?job=${encodeURIComponent(job['Job No'])}&date=${encodeURIComponent(job['Job Date'])}`;
      }

      let route = this.$router.resolve(url);
      window.open(route.href, '_blank');
    },

    containerUpdate: function (index) {
      this.containerUpdatePopup = true;
      this.containerJobNo = this.allJobs[index]['Job No'];

      this.showMoreList = new Array(this.showMoreList.length).fill(false);
    },

    getTransportIcon(desc) {
      if (!desc) return null;

      const map = {
        'by Sea': 'https://dsmlib.logistics.systems/Icons/bysea.png',
        'by Air': 'https://dsmlib.logistics.systems/Icons/byair.png',
        'by Rail': 'https://dsmlib.logistics.systems/Icons/byrail.png',
        'by Road': 'https://dsmlib.logistics.systems/Icons/byroad.png',
        General: 'https://dsmlib.logistics.systems/Icons/bygeneral.png',
      };

      return map[desc] || null;
    },
  },
  async mounted() {
    this.loading = true;

    this.userParam = this.$route.params['user'];

    this.loadText = 'Getting Date Field';
    this.dateFieldItems = await this.$apiCallV2('/JobMilestones/GetListMaster?master=JOBMILESTONES_DATEFIELD');

    this.loadText = 'Getting Date Option';
    this.dateOptionItems = await this.$apiCallV2('/JobMilestones/GetListMaster?master=JOBMILESTONES_DATEOPTION');

    this.loadText = 'Getting Service Person';
    this.servicePersonItems = await this.$apiCallV2('/JobMilestones/GetListMaster?master=JOBMILESTONES_SERVICEJOBS');

    this.loadText = 'Getting Status List Category';
    this.statusListCategoryItems = await this.$apiCallV2('/JobMilestones/GetListMaster?master=STATUSLISTCATEGORY');

    this.loadText = 'Getting Job Type';
    this.filterItems[0].items = await this.$apiCallV2('/JobMilestones/GetListMaster?master=SYSTEM_JOBTYPE');

    this.loadText = 'Getting Trans Mode';
    this.filterItems[1].items = await this.$apiCallV2('/JobMilestones/GetListMaster?master=TRANSMODEDESC');

    this.loadText = 'Getting Customers';
    this.filterItems[2].items = await this.$apiCallV2('/JobMilestones/GetListMaster?master=BILLCUSTNAME');

    this.loadText = 'Getting Shipper Consignee';
    this.filterItems[3].items = await this.$apiCallV2('/JobMilestones/GetListMaster?master=SHPRCSGNNAME');

    this.loading = false;

    await this.resetClicked();
  },
  watch: {
    jobDateSelect: function (val) {
      this.jobDateRange = !val;
      if (!val) {
        this.dateOptionError = '';
      }
    },
    jobDateRange: function (val) {
      this.jobDateSelect = !val;
      if (!val) {
        this.fromError = '';
        this.toError = '';
      }
    },
    showTabulator: function (val) {
      if (!val) {
        this.selectedItem = [];
        this.openedIndex = -1;
        this.showSelectedOnly = false;
      }
    },
    showSelectedOnly: function (val) {
      if (val) {
        this.tableData = this.selectedItem;
        for (var i = 0; i < this.selectedItem.length; i++) {
          this.$refs.popupTable.selectRow(i);
        }
      } else {
        this.tableData = this.filterItems[this.openedIndex].items;
        this.selectedItem.forEach((s) => {
          this.$refs.popupTable.selectRow(this.tableData.indexOf(s));
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.job-milestones-main {
  padding: 5px 45px;
  font-size: 12px;
  display: flex;

  > .left-container {
    height: 100%;
    min-width: 250px;
    background-color: white;
    border-radius: 5px;
    padding: 5px;
    display: flex;
    flex-direction: column;
    transition: $transition-time;
    overflow: hidden;

    > .button-section {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;

      > button {
        margin-right: 5px;
        font-size: 10px;
      }

      > img {
        height: 20px;
        cursor: pointer;
        justify-self: flex-end;
      }
    }

    > .date-section {
      border: 1px solid rgb(200, 200, 200);
      border-radius: 5px;
      padding: 10px;
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;

      > * {
        width: 100%;
      }
    }

    > .filters {
      position: relative;
      width: 100%;
      height: 100%;
      display: flex;
      flex-wrap: wrap;

      > .filter-items {
        min-width: calc(50% - 10px);
        flex-grow: 1;
        margin: 2px;
        font-size: 10px;
        display: flex;
        flex-direction: column;
        position: relative;

        > .filter-title {
          display: flex;
          align-items: center;
          position: absolute;
          height: 15px;
          width: 100%;

          > div {
            flex-grow: 1;
          }

          > button {
            margin: 0 2px;
            padding: 1px 2px;
          }
        }

        > .filter-details {
          padding: 0 3px;
          height: calc(100% - 20px);
          border: 1px solid rgb(200, 200, 200);
          margin-top: 2px;
          position: absolute;
          width: 100%;
          top: 16px;
          overflow-y: auto;

          > .item {
            cursor: pointer;
            padding: 2px;

            &:hover {
              background-color: rgba(200, 200, 200, 0.5);
            }
          }

          > .filter-empty {
            background-color: red;
            color: white;
            padding: 5px;
            border-radius: 5px;
            position: absolute;
            left: 3px;
            top: 3px;
            width: calc(100% - 6px);
            cursor: text;
          }
        }

        > textarea {
          position: absolute;
          height: calc(100% - 17px);
          resize: none;
          width: 100%;
          top: 17px;
          border: 1px solid rgb(200, 200, 200);

          &:focus {
            outline: none;
          }
        }
      }
    }
  }

  > .right-container {
    height: 100%;
    max-width: calc(100% - 250px);
    min-width: calc(100% - 250px);
    // background-color: blue;
    margin-left: 15px;
    display: flex;
    flex-direction: column;
    transition: $transition-time;

    > .selected-filters {
      background-color: white;
      border-radius: 5px;
      padding: 5px;
      position: relative;

      > .filter-row {
        width: 100%;
        display: flex;
        padding-bottom: 3px;

        > .filter-title {
          min-width: 110px;
        }

        > .filter-details {
          width: 100%;
          overflow-x: hidden;

          > .details-item {
            overflow-x: hidden;
            text-overflow: ellipsis;
          }

          > .details-dropdown {
            background-color: white;
            position: fixed;
            width: 100%;
            max-width: 250px;
            z-index: 999999;
            overflow-wrap: break-word;
            display: none;

            > .dropdown-content {
              margin-top: 6px;
              padding: 5px;
              border-radius: 5px;
              border: 1px solid rgb(200, 200, 200);
              box-shadow: 5px 5px 5px rgb(200, 200, 200);
            }

            > .dropdown-arrow {
              position: absolute;
              bottom: calc(100% - 6px);
              left: 5px;
              border-width: 0 8px 8px 8px;
              border-style: solid;
              border-color: transparent transparent #c8c8c8 transparent;
            }
          }

          &:hover .details-dropdown {
            display: unset;
          }
        }

        > .colon-separator {
          margin-right: 5px;
        }
      }

      > .empty-watch-list {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(200, 200, 200, 0.7);
        z-index: 10;
        display: flex;
        align-items: center;
        justify-content: center;
        font-weight: bolder;
        font-size: 15px;
      }

      > .last-refresh {
        position: absolute;
        top: 5px;
        right: 5px;
      }

      > .close-button {
        position: absolute;
        top: 0;
        left: -25px;
        padding: 5px;
        background-color: white;
        border: 1px solid rgb(150, 150, 150);
        border-radius: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;

        > img {
          transition: $transition-time;
        }
      }
    }

    > .legend {
      display: flex;
      background-color: white;
      padding: 5px;
      border-radius: 5px;
      margin: 5px 0;

      > .legend-item {
        background-color: red;
        margin-right: 5px;
        padding: 2px 10px;
        cursor: pointer;
        border: 1px solid red;
        user-select: none;
      }
    }

    > .jobs {
      height: 100%;
      overflow: auto;

      > .jobs-row {
        background-color: white;
        padding: 5px;
        margin-bottom: 5px;
        border-radius: 5px;
        display: flex;
        max-height: 85px;
        min-height: 85px;

        > .job-number {
          align-self: center;
          margin: 0 3px;
          min-width: 25px;
          max-width: 25px;
          text-align: right;
        }

        > .jobs-header {
          min-width: 120px;
          max-width: 120px;
          border: 1px solid rgb(200, 200, 200);
          padding: 3px;
          font-size: 10px;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: center;

          > .billto-name {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }

          .transport-icon {
            margin-left: auto;
            width: 18px;
            height: 18px;
          }

          > .cargo-type {
            position: absolute;
            right: 5px;
            top: 4px;
            font-size: 10px;
          }

          > .job-footer {
            display: flex;
            align-items: center;
            margin-top: 4px;

            .user-id {
              display: flex;
              align-items: center;
              gap: 6px;
              flex: 1;
            }

            .user-icon {
              width: 14px;
              height: 14px;
              opacity: 0.8;
            }
          }
        }

        > .image-wrapper {
          position: relative;
          display: flex;
          flex-direction: column;
          align-self: flex-end;

          > img {
            margin: 0 3px;
            border: 1px solid rgb(200, 200, 200);
            border-radius: 100%;
            cursor: pointer;
            padding: 3px;
            align-self: flex-end;
            margin: 3px;
          }

          > .more-menu {
            position: absolute;
            background-color: rgba(0, 0, 0, 0.9);
            color: white;
            border-radius: 5px;
            bottom: 0px;
            left: calc(100% + 5px);
            z-index: 99;
            width: 150px;
            display: flex;
            flex-direction: column;

            > .arrow {
              right: 100%;
              position: absolute;
              border-width: 10px;
              border-style: solid;
              border-color: transparent rgba(0, 0, 0, 0.9) transparent transparent;
            }

            > .show-more-item {
              border-bottom: 1px solid gray;
              padding: 5px;
              cursor: pointer;
              color: white;

              &:nth-child(2) {
                border-top-left-radius: 5px;
                border-top-right-radius: 5px;
              }

              &:last-child {
                border-bottom-left-radius: 5px;
                border-bottom-right-radius: 5px;
              }

              &:hover {
                background-color: rgb(118, 118, 118);
              }
            }
          }
        }

        > .tas-details {
          overflow: overlay;
          display: flex;
        }
      }
    }
  }

  > .tabulator-popup {
    width: 100%;
    height: calc(100% - 50px);
    position: fixed;
    left: 0;
    top: 50px;
    background-color: rgba(200, 200, 200, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 255;

    > .popup-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      overflow: hidden;
      background-color: white;
      width: 90%;
      height: 90%;
      padding: 10px;

      > .popup-header {
        display: flex;
        align-items: center;

        > .title {
          font-weight: bold;
          font-size: 15px;
          margin: 0 10px;
        }
      }

      > .confirm-cancel-buttton {
        position: relative;
        top: 45px;
        display: flex;

        > button {
          margin: 0 5px;
        }
      }
    }
  }
}

.flip-tas-details {
  transform: rotateY(180deg);
}

.flip-remarks {
  transform: rotateY(360deg) !important;
}

.separator {
  height: 1px;
  width: 100%;
  margin: 3px;
}
</style>

<style lang="scss">
.jobs-tas {
  min-width: 145px;
  max-width: 145px;
  margin-right: 3px;
  border: 1px solid rgb(200, 200, 200);
  font-size: 10px;
  position: relative;
  text-align: center;
  justify-content: center;
  align-items: center;
  display: none;
  cursor: pointer;
}

.show-tas {
  display: flex;

  > #details-wrap {
    width: 100%;
    align-self: flex-end;
    position: absolute;
    right: 0;
    text-align: right;

    > #attImg {
      width: 20px;
      position: relative;
      height: 20px;
      border: 1px solid #d8d8d8;
      border-radius: 100%;
      cursor: pointer;
      padding: 3px;
      margin: 2px;
      position: relative;
      background: #fff;
    }

    > .remarks-icon {
      cursor: pointer;
      margin: 2px;
    }
  }
}

//attachment popup
.attchWin-main {
  width: calc(100%);
  height: calc(100% - 10px);
  padding: 5px;
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  align-items: center;
  background-color: #00000048;
  z-index: 255;

  > .attchWin-close {
    height: 30px;
    width: 30px;
    font-weight: bold;
    border-radius: 50%;
    background-color: white;
    color: black;
    text-align: center;
    cursor: pointer;
    position: absolute;
    right: 0;
    top: 0;
    margin: 20px;
    font-size: 14px;
  }

  > .attchWin-display {
    width: 80%;
    margin: 0 auto;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    background-color: #eaeaea;
    border-radius: 3px;
    display: flex;
    height: 90vh;

    > .left {
      position: relative;
      float: left;
      width: 100%;
      height: 100%;
      border: 1px solid black;
      background: black;
      height: 100%;
      text-align: center;
      display: flex;

      > .leftButton {
        width: auto;
        height: 100%;
        float: left;
        align-items: center;
        left: 0;

        > .navButton-left {
          margin: 0 auot;
          position: relative;
          z-index: 300;
          font-size: 36px;
          color: white;
          background: none;
          top: 50%;

          &:hover {
            cursor: pointer;
            background: rgba(200, 200, 200, 0.8);
          }
        }
      }

      > .rightButton {
        width: auto;
        height: 100%;
        float: right;
        align-items: center;

        > .navButton-right {
          margin: 0;
          position: relative;
          top: 50%;
          float: right;
          /* -webkit-transform: translateY(-50%);
      transform: translateY(-50%); */
          z-index: 300;
          font-size: 36px;
          color: white;
          background: none;

          &:hover {
            cursor: pointer;
            background: rgba(200, 200, 200, 0.8);
          }
        }
      }

      > .attchWin-attachment {
        position: relative;
        margin: 0 auto;
        width: 80%;
        text-align: center;
        -o-object-fit: contain;
        object-fit: contain;
        float: left;
        align-self: center;
        //top: 25%;

        img {
          width: 70%;
          object-fit: contain;
          margin: 0 auto;
          max-height: 90vh;
        }

        &:hover {
          cursor: pointer;
        }

        iframe {
          width: 100%;
          height: 100%;
          min-height: 600px;
        }
      }
    }

    > .right {
      //position: relative;
      float: left;
      width: 500px;
      height: 100%;
      min-width: 250px;
      border: 1px solid black;
      display: grid;

      > .attchWin-info {
        position: relative;
        margin: auto 5px 0;
        text-align: left;
        margin: 5px;
        height: fit-content;
        overflow-x: auto;

        #infoHeader {
          width: 100%;
          table-layout: fixed;
          font-size: 12px;
          border-collapse: collapse;
          background: #d4dfeb;
          margin: 5px 0px;
          border: 1px solid black;

          td {
            padding: 3px;
          }
          th {
            font-weight: bold;
            width: 92px;
          }
        }

        #tableContent {
          width: 100%;
          position: relative;
          table-layout: fixed;
          font-size: 12px;
          border-collapse: collapse;
          margin: 20px auto;
          background: #fff;
          align-self: center;
          text-align: left;

          tr {
            border: 1px solid black;
            padding: 3px;
          }
          td {
            padding: 3px;
            border: 1px solid black;
            overflow-x: auto;
          }
          th {
            font-weight: bold;
            background: #d4dfeb;
            border: 1px solid black;
            padding: 3px;
            width: 97px;
          }
        }
      }
      > .count {
        position: relative;
        width: auto;
        text-align: center;
        margin: auto 3px 0;
        height: fit-content;
        border: 1px solid black;
        background: #a1a9b2;
      }
    }
  }
}
</style>
